<template>
  <header class="admin-header">
    <div class="header-toggle-sidenav" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>

    <div class="header-logo">
      <img alt="BCR logo" src="@/assets/images/front_logo.svg">
    </div>

    <div class="install-prompt__action header" v-show="prompt" v-if="mobile">
      <button @click="installer()">
        Instalar
      </button>
    </div>

    <div class="header-user">
      <vs-dropdown vs-custom-content vs-trigger-click class="user-info-dropdown">
        <vs-icon icon="person" class="mobile-user hidden-desktop"></vs-icon>
        <div class="logged-user hidden-mobile">
          <div class="user-name">{{ currentUser.firstname + ' ' + currentUser.lastname}}</div>
          <div class="user-email">{{ currentUser.email }}</div>
        </div>

        <a class="dropdown-expand-icon hidden-mobile" href.prevent>
          <vs-icon class="" icon="expand_more"></vs-icon>
        </a>

        <vs-dropdown-menu class="dropdown-items">
          <vs-dropdown-item disabled class="hidden-desktop">
            <div class="user-name">{{ currentUser.firstname + ' ' + currentUser.lastname}}</div>
            <div class="user-email">{{ currentUser.email }}</div>
          </vs-dropdown-item>
          <vs-divider class="hidden-desktop"/>
            <vs-dropdown-item>
              <router-link to="/admin/user-settings" @click.native="toggleDropdown()">
                <vs-icon icon="settings"></vs-icon> Configuración de cuenta
              </router-link>
            </vs-dropdown-item>
            <vs-dropdown-item @click="logout">
              <vs-icon icon="power_settings_new"></vs-icon>Cerrar sesión
            </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </header>
</template>

<script>
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'
import { mapMutations, mapState } from 'vuex'

const currentUser = gql`
  query currentUser($token: String!) {
    currentUser(token: $token) {
      cuil
      dni
      email
      firstname
      id
      lastname
      phone
      organizationId
      offerRole
      canBuy
      canSell
    }
  }
`

export default {
  data () {
    return {
      installBtn: 'none',
      installer: undefined
    }
  },
  computed: mapState({
    currentUser: state => state.User.currentUser,
    prompt: state => state.Pwa.prompt,
    mobile: state => state.Pwa.mobile
  }),
  created () {
    this.installer = () => {
      if (this.prompt) {
        this.installBtn = 'none'
        this.prompt.prompt()
        this.prompt.userChoice.then(result => {
          if (result.outcome === 'accepted') {
            //console.log("User accepted")
          } else {
            //console.log("User denied")
          }
          this.setPrompt(null)
        })
      }
    }
  },
  methods: {
    ...mapMutations('Pwa', [
      'setPrompt'
    ]),
    toggleMenu () {
      this.$root.$emit('toggleMenu')
    },
    logout () {
      this.$router.push('/login')
    }
  }
}
</script>
